import { useTranslation } from 'react-i18next'

import { ModalPriority, ModalTypes, useModalManager } from '@wwt/core/modals'

import { Button, ButtonProps } from '@/shared/ui/Button'

export const LoginButton = (props: ButtonProps) => {
	const { t } = useTranslation('header')

	const { showModal } = useModalManager()

	return (
		<Button
			data-wwt-id="header__sign-in--button"
			onClick={() => showModal(ModalTypes.Login, undefined, ModalPriority.high)}
			{...props}
		>
			{t('singIn')}
		</Button>
	)
}
